import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=09d2dd0c&"
import script from "./Tag.controller.js?vue&type=script&lang=js&"
export * from "./Tag.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Tag.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "63a1b4c5"
  
)

export default component.exports